<template>
  <pvd-loading-spinner
    active="true"
    type="brand"
    :message="pageTitle"
    class="mt-4"
  />
</template>
<script>

import dataHelper from '../mixins/dataHelper';

export default {
  name: 'TrustBackToMaestro',
  mixins: [
    dataHelper,
  ],
  data() {
    return {
      pageTitle: 'Sending email to client for review',
    };
  },
  created() {
    const { cid, tid } = this.getInstanceData().storageInfo;
    document.location.href = `${this.pd_envConfig.maestroURL}/completion?source=BDX_TrustAO&cid=${cid}&tid=${tid}`;
  },
  mounted() {
    document.title = this.setTitle(this.pageTitle);
  },
};

</script>

<style scoped>
  .mt-4{
    margin-top: 4rem;
  }
</style>
